import { createSlice } from "@reduxjs/toolkit";

const initialValues = {
  realEstate: [],
  bankBalances: [],
  securities: [],
  insurances: [],
  materials: [],
  shareholdings: [],
  corporateShareholdings: [],
  loans: [],
  others: [],
  donations: [],
  reload: false,
};

const initialState = {
  documents: initialValues,
};

export const assetsDocuments = createSlice({
  name: "assetsDocuments",
  initialState,
  reducers: {
    getAssetsDocuments: (state, action) => {
      state.documents = initialValues;
      action.payload.forEach((element) => {
        switch (element.sectionId) {
          case 1:
            state.documents = {
              ...state.documents,
              realEstate: [...state.documents.realEstate, { ...element }],
            };
            break;
          case 2:
            state.documents = {
              ...state.documents,
              bankBalances: [...state.documents.bankBalances, { ...element }],
            };
            break;
          case 3:
            state.documents = {
              ...state.documents,
              securities: [...state.documents.securities, { ...element }],
            };

            break;
          case 4:
            state.documents = {
              ...state.documents,
              insurances: [...state.documents.insurances, { ...element }],
            };

            break;
          case 5:
            state.documents = {
              ...state.documents,
              materials: [...state.documents.materials, { ...element }],
            };

            break;
          case 6:
            state.documents = {
              ...state.documents,
              shareholdings: [...state.documents.shareholdings, { ...element }],
            };

            break;
          case 7:
            state.documents = {
              ...state.documents,
              corporateShareholdings: [
                ...state.documents.corporateShareholdings,
                { ...element },
              ],
            };

            break;
          case 8:
            state.documents = {
              ...state.documents,
              others: [...state.documents.others, { ...element }],
            };

            break;
          case 10:
            state.documents = {
              ...state.documents,
              loans: [...state.documents.loans, { ...element }],
            };

            break;
          case 11:
            state.documents = {
              ...state.documents,
              donations: [...state.documents.donations, { ...element }],
            };

            break;

          default:
            break;
        }
      });
    },
    handleReloadFiles: (state) => {
      state.documents.reload = !state.reload;
    },
  },
});

export const { getAssetsDocuments, handleReloadFiles } =
  assetsDocuments.actions;

export default assetsDocuments.reducer;
